<template>
  <Teleport to="body">
    <div v-if="show" class="fixed inset-0 z-(--z-modal) flex items-center justify-center p-4">
      <div class="absolute inset-0 bg-backdrop" @click="handleClose"></div>
      <div
        class="relative flex flex-col rounded-card border border-line
               shadow-[var(--shadow-modal)]"
        :class="cardClass"
        role="dialog"
        aria-modal="true"
      >
        <div v-if="showClose" class="absolute top-4 right-4">
          <CloseButton @click="handleClose" />
        </div>
        <div class="flex flex-col text-text" :class="contentClass">
          <slot />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { watch, onBeforeUnmount } from 'vue';
import CloseButton from '@/components/elements/CloseButton.vue';

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  // off for confirm dialogs, where Cancel already closes it
  showClose: {
    type: Boolean,
    default: true,
  },
  cardClass: {
    type: String,
    default: 'min-w-80 max-w-[min(90vw,26.25rem)] bg-card p-4',
  },
  contentClass: {
    type: String,
    default: 'gap-3',
  },
});

const emit = defineEmits(['close']);

const handleClose = () => {
  emit('close');
};

function onKeydown(e) {
  if (e.key !== 'Escape') return;
  e.stopPropagation();
  handleClose();
}

watch(() => props.show, (show) => {
  if (show) {
    document.addEventListener('keydown', onKeydown, true);
  } else {
    document.removeEventListener('keydown', onKeydown, true);
  }
}, { immediate: true });

onBeforeUnmount(() => document.removeEventListener('keydown', onKeydown, true));
</script>
